import { useSyncExternalStore } from "react";

/** Same breakpoint as the CSS `@media (max-width: 820px)` that swaps sidebar for tab bar. */
export const MOBILE_QUERY = "(max-width: 820px)";

function subscribe(cb: () => void): () => void {
  if (typeof window === "undefined" || !window.matchMedia) return () => {};
  const mq = window.matchMedia(MOBILE_QUERY);
  mq.addEventListener("change", cb);
  return () => mq.removeEventListener("change", cb);
}
const snapshot = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(MOBILE_QUERY).matches : false);

/** True on phone-width viewports. Only used to pick a tailored layout of the SAME data; navigation stays CSS-driven. */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
